import {
  SEARCH_RESULTS_EVENT_NAME,
  SEARCH_RESULTS_EVENT_TYPE,
  SEARCH_RESULTS_PRIMARY_CATEGORY,
} from '~~/constants/googleTagManager';

import type { SearchResultCategoryType, SearchResultsAttributesType } from '~~/types/integrations/tagManager/TagManagerIntegration';

export const buildSearchResultsTags = (searchTerm: string = '') => ({
  event: SEARCH_RESULTS_EVENT_NAME,
  category: {
    event_type: SEARCH_RESULTS_EVENT_TYPE,
    primary_category: SEARCH_RESULTS_PRIMARY_CATEGORY,
  } as SearchResultCategoryType,
  attributes: {
    search_term: searchTerm,
  } as SearchResultsAttributesType,
});
